import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { API } from '../lib/site';
export const DEFAULT_CONTENT = { hero: {}, faqs: [], projects: [], testimonials: [], services: [] };
const ContentContext = createContext({ content: DEFAULT_CONTENT, documents: [], loaded: false });
export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [documents, setDocuments] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const refresh = useCallback(async () => {
    try {
      const [c, d] = await Promise.all([axios.get(`${API}/content/public`), axios.get(`${API}/documents`)]);
      setContent(c.data); setDocuments(d.data.documents || []); setError(false);
    } catch { setError(true); }
    finally { setLoaded(true); }
  }, []);
  useEffect(() => {
    refresh();
    const visible = () => { if (!document.hidden) refresh(); };
    window.addEventListener('focus', visible);
    document.addEventListener('visibilitychange', visible);
    window.addEventListener('melopa-content-updated', refresh);
    const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('melopa-content') : null;
    if (channel) channel.onmessage = refresh;
    return () => { window.removeEventListener('focus', visible); document.removeEventListener('visibilitychange', visible); window.removeEventListener('melopa-content-updated', refresh); channel?.close(); };
  }, [refresh]);
  const value = useMemo(() => ({ content, documents, loaded, error, refresh }), [content, documents, loaded, error, refresh]);
  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
};
export const useContent = () => useContext(ContentContext);
export const notifyContentSaved = () => { window.dispatchEvent(new Event('melopa-content-updated')); if (typeof BroadcastChannel !== 'undefined') {const c = new BroadcastChannel('melopa-content'); c.postMessage('saved'); c.close();} };
